import React from 'react';
import { ExternalLinkIcon, WalletCardsIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
const CHERRY_APPLICATION_URL = 'https://patient.withcherry.com/lipo-laser';
export function CherryFinancing() {
  const {
    lang
  } = useLanguage();
  const copy = lang === 'es' ? {
    eyebrow: 'FINANCIAMIENTO',
    label: 'Aplicar con Cherry',
    description: 'Opciones de pago'
  } : {
    eyebrow: 'FINANCING',
    label: 'Apply with Cherry',
    description: 'Payment options'
  };
  return <a href={CHERRY_APPLICATION_URL} target="_blank" rel="noopener noreferrer" aria-label={`${copy.label} — opens in a new tab`} className="fixed bottom-28 right-4 z-50 inline-flex items-center gap-3 rounded-full border border-[#936C56]/25 bg-[#936C56] px-4 py-3 text-white shadow-xl shadow-black/20 transition-colors hover:bg-[#7c5947] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 md:bottom-6 md:right-6" data-id="element-62" data-mp="33e8410ht6jyb">
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/15" data-id="element-63" data-mp="1hiipfcw99z9s">
        <WalletCardsIcon className="h-4 w-4" strokeWidth={1.8} data-id="element-64" data-mp="1cj62ks5dws77" />
      </span>
      <span className="flex flex-col items-start leading-none" data-id="element-65" data-mp="1cl8vpl1u31g5">
        <span className="mb-1 text-[9px] font-medium tracking-[0.16em] text-white/75" data-id="element-66" data-mp="17ld0aa77cic7">
          {copy.eyebrow}
        </span>
        <span className="text-xs font-semibold" data-id="element-67" data-mp="259wk3phvq6xx">{copy.label}</span>
        <span className="mt-1 text-[10px] text-white/75" data-id="element-68" data-mp="209s4s2spji9a">{copy.description}</span>
      </span>
      <ExternalLinkIcon className="h-3.5 w-3.5 text-white/70" strokeWidth={1.8} data-id="element-69" data-mp="1vgyxb75utvti" />
    </a>;
}